<div class="full-screen-spinner-container" *ngIf="loading$|async">
  <mat-spinner [diameter]="60" class="full-screen-spinner"></mat-spinner>
</div>
